import React, { Component } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import RegisterFootprint from './pages/realnamecheck/register-footprint'
import Login from './pages/login/login'
import Main from './pages/main/main'
import Outside from './pages/outside/outside'
import Faq from './pages/faq/faq'
import PublicObjectAlbum from './pages/culturalcreativeworks/public-object-album'
import Blog from './pages/blog/blog'
import ObjectWork from './pages/culturalcreativeworks/object-work'
import Sso from './pages/login/sso'
import Linesticker from './pages/linesticker/linesticker'
import SignerEnrolmentOpen from './pages/gatesecurity/signer-enrolment-open'
export default class App extends Component {
    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path='/footprint' component={RegisterFootprint}></Route>
                    <Route path='/login' component={Login}></Route>
                    <Route path='/blog' component={Blog}></Route>
                    <Route path='/gate' component={SignerEnrolmentOpen}></Route>
                    <Route path='/sso' component={Sso}></Route>
                    <Route path='/default' component={Outside}></Route>  {/*公開頁*/}
                    <Route path='/line' component={Linesticker}></Route>  {/*Line比賽官網*/}
                    <Route path='/album' component={PublicObjectAlbum}></Route>
                    <Route path='/object' component={ObjectWork}></Route>
                    <Route path='/faq' component={Faq}></Route>
                    <Route path='/' component={Main}></Route>
                    <Redirect to="/" />
                </Switch>
            </BrowserRouter>
        )
    }
}